// src/components/Home.js
import React, { useContext, useState, useEffect } from "react";
import { MediaContext } from '../contexts/MediaContext';
import { CategoryContext } from '../contexts/CategoryContext';
import { ClassContext } from '../contexts/ClassContext';
import { Link } from "react-router-dom";
import axios from "axios";
import Hero from "./Hero";
import Category from "./Category";
import Class from "./Class";
import Slider from "./Slider";
import MapsGrid from './MapsGrid';
import AnfrageForm from './AnfrageForm';
import Loader from './Loader';
import KlasseA from '../assets/Klasse_A_1000x300.jpg';
import Gutschein from '../assets/Gutschein_1000x300.jpg';
import FahrzeugGallery from "./FahrzeugGallery";
import TestimonialsSlider from "./TestimonialsSlider";
import '../styles/Home.css';
import HobexTestButton from "./HobexTestButton";


const Home = () => {
  const [message, setMessage] = useState(null);

  const { fsImages, fzImages, loading: loadingMedia, error: errorMedia } = useContext(MediaContext);
  const { kategorien, loadingKategorien, errorKategorien } = useContext(CategoryContext);
  const { klassen, loadingKlassen, errorKlassen } = useContext(ClassContext);

  const [werbebannerData, setWerbebannerData] = useState([]);
  const [loadingWerbebanner, setLoadingWerbebanner] = useState(true);
  const [errorWerbebanner, setErrorWerbebanner] = useState(null);

  const Werbebanner_API_URL = process.env.REACT_APP_API_BASE_URL + '/items/Werbebanner?fields=*.*';
  
  useEffect(() => {
      const fetchWerbebanner = async () => {
      try {
          const response = await axios.get(Werbebanner_API_URL);
          if (response.data && response.data.data) {
              setWerbebannerData(response.data.data);
          } else {
              setErrorWerbebanner('Werbebanner konnten nicht geladen werden');
          }
          } catch (error) {
              setErrorWerbebanner('Werbebanner konnten nicht geladen werden');
              console.error(error);
          } finally {
              setLoadingWerbebanner(false);
          }
      };

      fetchWerbebanner();
  }, []);

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage(null);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [message]);
  


  if (loadingMedia || loadingKategorien || loadingKlassen) {
    return <Loader />;
  }

  if (errorMedia || errorKategorien || errorKlassen) {
    return (
      <div>
        {errorMedia && <p className="error">{errorMedia}</p>}
        {errorKategorien && <p className="error">{errorKategorien}</p>}
        {errorKlassen && <p className="error">{errorKlassen}</p>}
      </div>
    );
  }

  const sortedFsImages = fsImages.slice().sort((a, b) => {
    const titleA = a.title || "";
    const titleB = b.title || "";
    const numA = titleA.match(/\d+/) ? parseInt(titleA.match(/\d+/)[0], 10) : 0;
    const numB = titleB.match(/\d+/) ? parseInt(titleB.match(/\d+/)[0], 10) : 0;

    return numA - numB;
  });

  const sortedFzImages = fzImages.slice().sort((a, b) => {
    const titleA = a.title || "";
    const titleB = b.title || "";
    const numA = titleA.match(/\d+/) ? parseInt(titleA.match(/\d+/)[0], 10) : 0;
    const numB = titleB.match(/\d+/) ? parseInt(titleB.match(/\d+/)[0], 10) : 0;

    return numA - numB;
  });


  return (
    <div className="">
      <Hero />
      <Category />
      {/* <Class />  */}
      {/* <ImageGallery/> */}

      {/* <HobexTestButton/> */}

      <TestimonialsSlider />

      {!loadingWerbebanner && !errorWerbebanner && (
        <div className="werbung">
          {werbebannerData.Link_1 ? (
            <Link to={werbebannerData.Link_1} target={`${werbebannerData.Neues_Fenster_1 ? '_blank' : '_self'}`}>
              <img className="test" src={`${process.env.REACT_APP_API_BASE_URL}/assets/${werbebannerData.Bild_1.filename_disk}`} />
            </Link>
          ) : (
            <img className="test" src={`${process.env.REACT_APP_API_BASE_URL}/assets/${werbebannerData.Bild_1.filename_disk}`} />
          )}
          {/* <img className="portrait" src={KlasseA} /> */}
        </div>
      )}

      {/* Первый слайдер с динамическими изображениями / Erster Slider mit dynamischen Bildern */}
      {/* <Slider
        title="Deine Fahrschule mit Drive<span>O wie Orange Drivers, O wie optimale Lernumgebung!</span>"
        subtitle="Bei uns wird aus trockener Theorie ein spritziges Fahrerlebnis. In unseren modernen Räumen und mit unserem top-motivierten Team bist du bestens vorbereitet – und hast dabei auch noch Spaß. Melde dich jetzt an und starte durch!"
      >
        {sortedFsImages.map((file) => {
          const imageUrl = `${process.env.REACT_APP_API_BASE_URL}/assets/${file.filename_disk}`;
          return (
            <img
              key={file.id}
              className="sliderImg"
              src={imageUrl}
              alt={file.title || "Media"}
            />
          );
        })}
      </Slider> */}

      {/* Второй слайдер с изображениями, отфильтрованными по тегу 'fz' / Zweiter Slider mit Bildern, die nach dem Tag 'fz' gefiltert sind */}
      {/* <Slider
        className='blue'
        title="Unterwegs mit Style"
        subtitle="Ob auf zwei oder vier Rädern – unsere hochmodernen Fahrzeuge bringen dich sicher ans Ziel. Innovativ, zuverlässig und bereit für deine ersten Kilometer. Schnapp dir dein Fahrzeug und leg los!"
      >
        {sortedFzImages.map((file) => {
          const imageUrl = `${process.env.REACT_APP_API_BASE_URL}/assets/${file.filename_disk}`;
          return (
            <img
              key={file.id}
              className="sliderImg"
              src={imageUrl}
              alt={file.title || "Media"}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholder.png";
              }}
            />
          );
        })}
      </Slider> */}
      <FahrzeugGallery />
      <MapsGrid />
      
      {!loadingWerbebanner && !errorWerbebanner && (
        <div className="werbung werbung2">
          {werbebannerData.Link_2 ? (
            <a href={werbebannerData.Link_2} target={`${werbebannerData.Neues_Fenster_2 ? '_blank' : '_self'}`}>
              <img className="test" src={`${process.env.REACT_APP_API_BASE_URL}/assets/${werbebannerData.Bild_2.filename_disk}`} />
            </a>
          ) : (
            <img className="test" src={`${process.env.REACT_APP_API_BASE_URL}/assets/${werbebannerData.Bild_2.filename_disk}`} />
          )}
          {/* <img className="portrait" src={KlasseA} /> */}
        </div>
      )}

      <AnfrageForm setMessage={setMessage} />
      {message && (
        <div className={`message-box ${message.type}`}>
          {message.text}
        </div>
      )}

    </div>
  );
};

export default Home;
